module.exports = __webpack_public_path__ + "img/footage.d56b0145.png";